import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Icon from '@material-ui/core/Icon';
import Typography from '@material-ui/core/Typography';
import i18n from '../../i18n';
import Layout from '../../components/Layout';
import CsrfField from "../../components/Form/CsrfField";
import FormField from "../../components/Form/FormField";
import styles from './styles';

const Login = ({classes, errors}) => (
    <Layout>
        <div className={classes.main}>
            <Paper className={classes.paper}>
                <Avatar className={classes.avatar}>
                    <Icon>lock</Icon>
                </Avatar>

                <Typography
                    component="h1"
                    variant="h5"
                    align="center"
                >
                    {i18n.get('user.login')}
                </Typography>

                <form
                    className={classes.form}
                    method="POST"
                    action="/login"
                >
                    <CsrfField/>

                    <FormField
                        id="email"
                        type="email"
                        name="email"
                        label={i18n.get('user.form.email')}
                        touched={errors.email}
                        error={errors.email && errors.email[0]}
                    />

                    <FormField
                        id="password"
                        type="password"
                        name="password"
                        label={i18n.get('user.form.password')}
                        touched={errors.password}
                        error={errors.password && errors.password[0]}
                    />

                    {/*<FormCheck*/}
                    {/*    name="remember"*/}
                    {/*    label={i18n.get('user.password.remember')}*/}
                    {/*/>*/}

                    <Button
                        fullWidth
                        type="submit"
                        variant="contained"
                        color="primary"
                        className={classes.spaceButton}
                    >
                        {i18n.get('user.login')}
                    </Button>

                    <Button
                        fullWidth
                        component="a"
                        href="/register"
                        className={classes.spaceButton}
                    >
                        {i18n.get('user.register')}
                    </Button>

                    <Button
                        fullWidth
                        component="a"
                        href="/password/reset"
                        className={classes.spaceButton}
                    >
                        {i18n.get('user.password.forget')}
                    </Button>
                </form>
            </Paper>
        </div>
    </Layout>
);

export default withStyles(styles)(Login);
